import { useRef } from "react";

/**
 * Props para el fondo de un modal: cierra al hacer clic fuera, pero solo si
 * el gesto EMPEZÓ en el fondo.
 *
 * Con un `onClick` a secas no basta: al seleccionar texto dentro del modal y
 * soltar el ratón fuera, el `click` se dispara en el ancestro común —el propio
 * fondo— y el modal se cerraba perdiendo lo escrito.
 *
 * Uso: <Overlay {...useBackdropClose(onClose)}>
 */
export default function useBackdropClose(onClose) {
  const startedOnBackdrop = useRef(false);

  return {
    onMouseDown: (e) => {
      startedOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const isBackdropClick = startedOnBackdrop.current && e.target === e.currentTarget;
      startedOnBackdrop.current = false;
      if (isBackdropClick) onClose();
    },
  };
}
